import { Component, Vue } from 'vue-property-decorator';

@Component
export default class B2BJhiFooter extends Vue {
  get isHomepage(): boolean {
    return this.$route.path === '/b2b';
  }

  get isNewsOrQuestions(): boolean {
    return this.$route.path.startsWith('/b2b/news') || this.$route.path.startsWith('/b2b/questions');
  }
}
